"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cosmos_1 = require("components/cosmos");
const constants_1 = require("components/cosmos/toast/constants");
const translate_1 = require("components/translate");
const UploadImageInput_1 = __importDefault(require("components/UploadImageInput"));
const auth_1 = require("modules/auth");
const constants_2 = require("modules/content/moduleEditor/constants");
const constants_3 = require("modules/file/constants");
const membership_1 = require("modules/membership");
const ui_1 = require("modules/ui");
const upload_1 = require("modules/upload");
const ModuleEditorService_1 = __importDefault(require("../../../ModuleEditorService"));
const ModuleCoverForm = ({ coverImageUrl, t }) => {
    const setCoverImageId = (coverImageId) => {
        ModuleEditorService_1.default.coverImageId = coverImageId;
    };
    const setCoverImageUrl = (coverImageUrl) => {
        ModuleEditorService_1.default.coverImageUrl = coverImageUrl;
    };
    const handleImageChange = async (file) => {
        if (file) {
            try {
                const imageId = await upload_1.UploadService.uploadFile(file, membership_1.MembershipStore.marketplaceId, constants_3.ENTITY_TYPE.MODULE_COVER_IMG, auth_1.AuthService.token);
                const imagePreviewUrl = await upload_1.UploadService.getPreviewUrl(file);
                setCoverImageId(imageId);
                setCoverImageUrl(imagePreviewUrl);
            }
            catch (_a) {
                ui_1.UiService.setAlertWithText({
                    type: constants_1.TOAST_TYPE.danger,
                    message: t('alerts.failed_upload')
                });
            }
        }
        else {
            setCoverImageId(null);
            setCoverImageUrl(null);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(cosmos_1.InputLabel, { htmlFor: "image", className: "_text-2 _font-weight-bold _text-gray-900 _mb-2", children: t('module_editor.module_cover.title') }), (0, jsx_runtime_1.jsx)("div", { className: "_text-2 _text-gray-600 _mb-3", children: t('module_editor.module_cover.subtitle', {
                    data: {
                        width: constants_2.IMAGE_RECOMMENDED_WIDTH,
                        height: constants_2.IMAGE_RECOMMENDED_HEIGHT
                    }
                }) }), (0, jsx_runtime_1.jsx)(UploadImageInput_1.default, { width: 300, height: 169, image: coverImageUrl, onUpload: handleImageChange, label: t('module_editor.module_cover.button') })] }));
};
exports.default = (0, translate_1.translate)()(ModuleCoverForm);
